import { gluer } from 'femo';
import { getAccountAppliedProcessPendingCount, getAccountTransferCount } from '@src/pages/Law/AccountManage/service';
export const approvalCountModel = gluer(0);
export const transferCountModel = gluer(0);
export const getApprovalCount = () => approvalCountModel.race(() => getAccountAppliedProcessPendingCount());
export const getTransferCount = () => transferCountModel.race(() => getAccountTransferCount());
